module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/260-united-kingdom-dbb21dac8c2a2be63b225618e4a54b76.svg";